
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetail } from '@/interfaces/title-details-graphql';

// import { shouldClickMask } from '@/components/click-masking/click-masking-config';

import BuyBoxOffer from '@/components/buybox/BuyBoxOffer.vue';
import UseOfferImpressionTracking from '@/helpers/composables/useOfferImpressionTracking';
import type { SponsoredAdFragmentFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import BuyBoxBundle from '@/components/buybox/BuyBoxBundle.vue';

const Language = namespace('language');

type BuyboxRowOffer = TitleOfferFragment & {
	iconUrl?: string;
	bundleId?: number;
	bundleTechnicalName?: string;
};

@Component({
	name: 'BuyBoxRow',
	components: {
		BuyBoxOffer,
		UseOfferImpressionTracking,
		BuyBoxBundle,
	},
})
export default class BuyBoxRow extends Vue {
	@Prop({ required: true }) title: TitleDetail;
	@Prop({ default: false }) promoted: boolean;
	@Prop({ default: false }) inline: boolean;
	@Prop({ default: false }) hideCategoryLabel: boolean;
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];
	@Prop({ default: null }) sponsoredAd: SponsoredAdFragmentFragment;

	@Prop({ default: () => [] }) offers: BuyboxRowOffer[];
	// START AVOD
	@Prop({ default: false }) isAVODActive: boolean;
	// END AVOD
	@Language.Getter country: string;
	@Language.Getter isTTBLanguage: string;

	get bundleCondition() {
		const bundleIds = [8, 210, 29];
		return (
			(this.country === 'GB' || this.country === 'IE') &&
			this.offers.some(el => bundleIds.includes(el.package.packageId))
		);
	}

	get skyOrNetflixOffer() {
		const bundleIds = [8, 210, 29];
		return this.offers.find(el => bundleIds.includes(el.package.packageId));
	}

	get rowOffers() {
		// START AVOD
		if (this.isAVODActive) {
			return this.offers.filter(el => el.package.technicalName !== 'plex');
		}
		return this.offers.filter(el => el.package.technicalName !== 'plexplayer');
		// END AVOD

		// To-DO SR overrideBuyboxClickout
		// if (this.sponsoredAd?.campaign.node.id !== this.titleId) {
		// 	return this.categoryOffers.filter(
		// 		({ package: p }) => !shouldClickMask(p.packageId, this.country, { andHide: true })
		// 	);
		// }
		// if (!this.isSponsoredRecommendation)
		// return this.categoryOffers.map(offer => {
		// 	if (sponsoredTitle.overrideBuyboxClickout && sponsoredTitle.provider_id === offer.package.packageId) {
		// 		return {
		// 			...offer,
		// 			standardWebURL:
		// 				sponsoredTitle.content.watchNowOffer[this.country]?.standardWebURL ?? offer.standardWebURL,
		// 		};
		// 	}

		// 	return offer;
		// });
	}
}
